import * as React from 'react';
import { Tooltip, Chip, Typography } from '@mui/material';

function renderStatus(status) {
  const colors = {
    completed: 'success',
    available: 'success',
    recovery: 'success',
    off: 'default',
    arrived: 'default',
  };

  return <Tooltip title={status.name} arrow>
    <Chip label={status?.code} color={colors[status?.name]} size="small" />
  </Tooltip>
}

function renderType(type) {
  if(Array.isArray(type)) {
    return type.map(t => 
      {
      return <Chip key={t} label={t} />}
    );
  } else {
    return type;
  }
}

export const getPatrolsColumns = (statuses, resourceTypes) => [
  {
    field: 'fullName',
    headerName: 'Name',
    flex: 1,
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    renderCell: (params) => (
      <Tooltip title={params.value || ''} arrow>
        <Typography noWrap variant='body2' sx={{mt: '7px'}}>
          {params.value}
        </Typography>
      </Tooltip>
    )
  },
  { 
    field: 'callsign', 
    headerName: 'Call Sign', 
    flex: 1, 
    minWidth: 80 ,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 0.5,
    minWidth: 100,
    renderCell: (params) => renderStatus(params.row.status, statuses),
    valueGetter: (value) => {
      const status = statuses.find(s => s.id === value.id);
      return status?.code || '';
    },
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'resourceType',
    headerName: 'Type',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    minWidth: 80,
    renderCell: (params) => renderType(params.value),
    valueGetter: (value) => {
      const type = resourceTypes.filter(s => value.includes(s.id)).map(t => t.code);
      return type ||  [];
    },
  },
  {
    field: 'assignedTasks',
    headerName: 'Assignments',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 80,
    type: 'number',
    valueGetter: (params) => params?.length ?? 0
  },
  {
    field: 'vehicleVrn',
    headerName: 'Reg #',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 100,
    
  },
  {
    field: 'shift1',  
    headerName: 'Shift Start',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    minWidth: 120,
    valueGetter: (column, row) => row.shift?.split('/')[0],
  },
  {
    field: 'shift2',
    headerName: 'Shift End',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    minWidth: 120,
    valueGetter: (column, row) => row.shift?.split('/')[1],
  },
  
];
